/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Delete_Event_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Event" |
*
* @param {Shortcut_Keys_Delete_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_delete_event_title = /** @type {((inputs?: Shortcut_Keys_Delete_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Delete_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir evento")
	return /** @type {LocalizedString} */ ("Delete Event")
});